<div class="connection-indicator" [matTooltip]="tooltip">
  <mat-icon [style]="{ color: color }">brightness_1</mat-icon>
</div>
